import { RouteConfig } from 'vue-router';

/**
 * 商品类路由
 */
export default [
  // /**
  //  * 重审卡
  //  */
  // {
  //   path: '/goods/retrial-card',
  //   meta: {
  //     title: '重审卡',
  //     customNavBar: true,
  //   },
  //   component: () => import('@/views/goods/retrial-card/index.vue'),
  // },
  /**
   * 享借卡
   */
  {
    path: '/goods/comfort-card',
    meta: {
      title: '享借卡',
      excludeLogin: true,
      background: '#FFF7F2',
      customNavBar: true,
    },
    component: () => import('@/views/goods/comfort-card/index.vue'),
  },
  /**
   * 享借卡已购
   */
  {
    path: '/goods/comfort-card/bought',
    meta: {
      title: '享借卡',
      background: '#FFF7F2',
      customNavBar: true,
    },
    component: () => import('@/views/goods/comfort-card/bought.vue'),
  },
  /**
   * 加速宝
   */
  {
    path: '/goods/accelerator',
    meta: {
      title: '加速宝',
      background: '#fff',
      customNavBar: true,
    },
    component: () => import('@/views/goods/accelerator/index.vue'),
  },

  /**
   * 悦享借315页面
   */
  {
    path: '/goods/compensate-card-static',
    meta: {
      title: '悦享借',
      background: '#F8F9FF',
      customNavBar: true,
    },
    component: () => import('@/views/goods/compensate-card-static/index.vue'),
  },
  /**
   * 悦享借
   */
  {
    path: '/goods/compensate-card',
    meta: {
      title: '悦享借',
      background: '#F8F9FF',
      customNavBar: true,
    },
    component: () => import('@/views/goods/compensate-card/index.vue'),
  },

  /**
   * 悦享借已购页
   */
  {
    path: '/goods/compensate-card/bought',
    meta: {
      title: '悦享借',
      background: '#F8F9FF',
      customNavBar: true,
    },
    component: () => import('@/views/goods/compensate-card/bought.vue'),
  },

  /**
   * 砺带版悦享借
   */
  {
    path: '/goods/compensate-card-lidai',
    meta: {
      title: '悦享借',
      background: '#F8F9FF',
      customNavBar: true,
    },
    component: () => import('@/views/goods/compensate-card-lidai/index.vue'),
  },

  /**
   * 砺带版悦享借已购页
   */
  {
    path: '/goods/compensate-card-lidai/bought',
    meta: {
      title: '悦享借',
      background: '#F8F9FF',
      customNavBar: true,
    },
    component: () => import('@/views/goods/compensate-card-lidai/bought.vue'),
  },
  /**
   * 砺带版悦享借新版
   */
  {
    path: '/goods/compensate-card-lidai-new',
    meta: {
      title: '悦享借',
      background: '#F8F9FF',
      customNavBar: true,
    },
    component: () => import('@/views/goods/compensate-card-lidai-new/index.vue'),
  },

  /**
   * 砺带版悦享借新版已购页
   */
  {
    path: '/goods/compensate-card-lidai-new/bought',
    meta: {
      title: '悦享借',
      background: '#F8F9FF',
      customNavBar: true,
    },
    component: () => import('@/views/goods/compensate-card-lidai-new/bought.vue'),
  },
  /**
   * 省钱卡
   */
  {
    path: '/goods/save-money-card',
    meta: {
      title: '权益礼包',
      background: '#F8F9FF',
      customNavBar: true,
      excludeLogin: true,
    },
    component: () => import('@/views/goods/save-money-card/index.vue'),
  },
  /**
   * 生活月卡
   */
  {
    path: '/goods/life-month-card',
    meta: {
      title: '生活月卡',
      background: '#F3F5F7',
      customNavBar: true,
    },
    component: () => import('@/views/goods/life-month-card/index.vue'),
  },
  /**
   * 生活月卡已购
   */
  {
    path: '/goods/life-month-card/bought',
    meta: {
      title: '生活月卡',
      background: '#F3F5F7',
      customNavBar: true,
    },
    component: () => import('@/views/goods/life-month-card/bought.vue'),
  },
  /**
   * 会员月卡-新
   */
  {
    path: '/goods/vip-month-card-new',
    meta: {
      title: '臻选计划',
      background: '#f5f6fa',
      customNavBar: true,
      excludeLogin: true,
      excludeTracking: true,
    },
    component: () => import('@/views/goods/vip-month-card-new/index.vue'),
  },
  /**
   * 会员月卡已购-新
   */
  {
    path: '/goods/vip-month-card-new/bought',
    meta: {
      title: '臻选计划',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/goods/vip-month-card-new/bought.vue'),
  },

  /**
   * 会员月卡-v2
   */
  {
    path: '/goods/vip-month-card-v2',
    meta: {
      title: '臻选计划',
      background: '#f5f6fa',
      customNavBar: true,
      excludeLogin: true,
      excludeTracking: true,
    },
    component: () => import('@/views/goods/vip-month-card-v2/index.vue'),
  },
  /**
   * 会员月卡已购-v2
   */
  {
    path: '/goods/vip-month-card-v2/bought',
    meta: {
      title: '臻选计划',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/goods/vip-month-card-v2/bought.vue'),
  },

  /**
   * 会员月卡
   */
  {
    path: '/goods/vip-month-card',
    meta: {
      title: '臻选计划',
      background: '#f5f6fa',
      customNavBar: true,
      excludeLogin: true,
      excludeTracking: true,
    },
    component: () => import('@/views/goods/vip-month-card/index.vue'),
  },
  /**
   * 会员月卡详情
   */
  {
    path: '/goods/vip-month-card/detail',
    meta: {
      title: '权益详情',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/goods/vip-month-card/detail.vue'),
  },
  /**
   * 会员月卡已购
   */
  {
    path: '/goods/vip-month-card/bought',
    meta: {
      title: '臻选计划',
      background: '#f5f6fa',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/goods/vip-month-card/bought.vue'),
  },

  {
    path: '/goods/tab-vip-month-card',
    redirect: '/goods/vip-month-card',
  },
  {
    path: '/goods/tab-vip-month-card/bought',
    redirect: '/goods/vip-month-card/bought',
  },
  {
    path: '/goods/tab-vip-month-card/detail',
    redirect: '/goods/vip-month-card/detail',
  },

  /**
   * 速通卡未购页
   */
  {
    path: '/goods/fast-pass-card',
    meta: {
      title: '速通卡',
      background: '#F8F9FF',
      customNavBar: true,
    },
    component: () => import('@/views/goods/fast-pass-card/index.vue'),
  },

  /**
   * 速通卡已购页
   */
  {
    path: '/goods/fast-pass-card/bought',
    meta: {
      title: '速通卡',
      background: '#f4f4f4',
      customNavBar: true,
    },
    component: () => import('@/views/goods/fast-pass-card/bought.vue'),
  },
  /**
   * 速通卡入口页
   */
  {
    path: '/goods/fast-pass-card/limit-result',
    meta: {
      title: '我的额度',
      background: '#f4f4f4',
      customNavBar: true,
    },
    component: () => import('@/views/goods/fast-pass-card/limit-result.vue'),
  },
  /**
   * 速通卡重审loading页
   */
  {
    path: '/goods/fast-pass-card/waiting',
    meta: {
      title: '审核中',
      background: '#f4f4f4',
      customNavBar: true,
    },
    component: () => import('@/views/goods/fast-pass-card/waiting.vue'),
  },

  /**
   * 速通卡重审失败结果页
   */
  {
    path: '/goods/fast-pass-card/rejected',
    meta: {
      title: '审核中',
      background: '#f4f4f4',
    },
    component: () => import('@/views/goods/fast-pass-card/rejected.vue'),
  },
  /**
   * 会员月卡-tab入口
   */
  {
    path: '/goods/tab-vip-month-card',
    meta: {
      title: ' ',
      background: '#F5F6FA',
      customNavBar: true,
      excludeLogin: true,
      excludeTracking: true,
    },
    component: () => import('@/views/goods/vip-month-card/index.vue'),
  },
  /**
   * 会员月卡-tab入口
   */
  {
    path: '/goods/tab-vip-month-card/bought',
    meta: {
      title: ' ',
      background: '#F5F6FA',
      customNavBar: true,
      excludeLogin: true,
      excludeTracking: true,
    },
    component: () => import('@/views/goods/vip-month-card/bought.vue'),
  },
  /**
   * 提额卡
   */
  {
    path: '/goods/raise-credit-limit-card',
    meta: {
      title: '提额卡',
      background: '#F5F6FA',
      customNavBar: true,
    },
    component: () => import('@/views/goods/raise-credit-limit-card/index.vue'),
  },
  /**
   * 提额卡已购页
   */
  {
    path: '/goods/raise-credit-limit-card/bought',
    meta: {
      title: '提额结果',
      background: '#F8F9FF',
      customNavBar: true,
    },
    component: () => import('@/views/goods/raise-credit-limit-card/bought.vue'),
  },
  /**
   * 跃升卡
   */
  {
    path: '/goods/upgrade-card',
    meta: {
      title: '跃升服务',
      background: '#017eff',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/goods/upgrade-card/index.vue'),
  },
  /**
   * 跃升服务等待页
   */
  {
    path: '/goods/upgrade-card/waiting',
    meta: {
      title: '资金匹配',
      background: '#fff',
      customNavBar: true,
    },
    component: () => import('@/views/goods/upgrade-card/waiting.vue'),
  },
] as RouteConfig[];
